var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5417 20.8172V12.0484L2.875 7.61615V15.3068C2.875 15.6582 2.95885 15.9776 3.12656 16.2651C3.29427 16.5526 3.52986 16.7842 3.83333 16.9599L10.5417 20.8172ZM12.4583 20.8172L19.1667 16.9599C19.4701 16.7842 19.7057 16.5526 19.8734 16.2651C20.0411 15.9776 20.125 15.6582 20.125 15.3068V7.61615L12.4583 12.0484V20.8172ZM16.2677 7.6401L19.0948 5.98698L12.4583 2.1776C12.1549 2.00191 11.8354 1.91406 11.5 1.91406C11.1646 1.91406 10.8451 2.00191 10.5417 2.1776L8.64896 3.25573L16.2677 7.6401ZM11.5 10.3953L14.351 8.76615L6.75625 4.35781L3.88125 6.01094L11.5 10.3953Z",
    fill: "#695BD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage2);
export default __webpack_public_path__ + "static/media/package_2.b800f81e8b16cfda9e3906d89a6fbf63.svg";
export { ForwardRef as ReactComponent };